import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {insertEmployeeType,getEmployeeType,deleteEmployeeType,getPayRoleType,} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import { getSecureItem } from "../../services/SecureStorage";

export default function EmployeeType() {
  const UID = getSecureItem("userId");
  const [addEmployeeTypeModal, setAddEmployeeTypeModal] = useState(false);
  const [editEmployeeTypeModal, setEditEmployeeTypeModal] = useState(false);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [payrole, setPayrole] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const [isloading, setisloading] = useState(false)
  const [deleteEmpTypeId, setDeleteEmpTypeID] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const [employeeTypeData, setEmployeeTypeData] = useState({
    Id: "",
    Name: "",
    Narration: "",
    Code: "",
    PayRole: "",
    UserId: UID,
  });
  const openAddEmployeeTypeModal = () => {
    setEmployeeTypeData({
      Id: "",
      Name: "",
      Narration: "",
      Code: "",
      PayRole: "",
      UserId: UID,
    });
    setAddEmployeeTypeModal(!addEmployeeTypeModal);
  };
  const openEditEmployeeTypeModal = (data) => {
    console.log("data", data);
    // profitcenter id name
    const CategoryName = payrole.find((item) => {
      if (item.Id == data?.PayroleId) {
        console.log(payrole, "crProfit");
        console.log(item, "critem");
        return item?.Name;
      }
    });
    console.log("CategoryName", CategoryName);

    setEmployeeTypeData({
      ...data,
      CategoryId: data?.CategoryId,
      // DepartmentId: data.DepartmentId,
      CategoryName: CategoryName?.Name,
      // Department: DepartmentName?.Name,
      UserId: UID || "",
    });
    setEditEmployeeTypeModal(!editEmployeeTypeModal);
  };

  const fetchEmployeeTypes = async () => {
    try {
      const data = await getEmployeeType(UID);
      console.log(data.data.data, "Fetched data");
      setEmployeeTypes(data.data.data);
    } catch (error) {
      console.error("Error fetching employeeTypes", error);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployeeTypeData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setisloading(true);

    try {
      const response = await insertEmployeeType(employeeTypeData);

      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchEmployeeTypes();
        openAddEmployeeTypeModal();
      }
    
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error(errorMessage);
      } else {
        toast.error("Error occurred while adding Employee Type.");
      }
      console.error("Error adding Employee Type:", error);
    }
    finally {
      setisloading(false);
    }

  };

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);
    

    try {
      const response = await insertEmployeeType(employeeTypeData);

      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchEmployeeTypes();
        openEditEmployeeTypeModal();
      } 

    } catch (error) {
      const errorMessage =
      error.response?.data?.error ||
      error.message ||
      "An unexpected error occurred.";

    if (errorMessage.includes("Duplicate Name")) {
      toast.error(errorMessage);
    } else {
      toast.error("Error occurred while editing Employee Type.");
    }
    console.error("Error editing Employee Type:", error);
    }
    finally {
      setLoading(false);
    }
   
  };

  const handleDelete = async (employeeTypeId) => {
    const removeData = { Id: employeeTypeId, TableName: "EmployType" };
    try {
      const res = await deleteEmployeeType(removeData, UID); // Ensure deleteEmployeeType is asynchronous.
      if (res && res.data) {
       
        if (res.data.message === "Deleted Successfully") {
          toast.success("Employee Type deleted successfully");
          fetchEmployeeTypes();
        } else {
          toast.error("Unexpected response from the server.");
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Employee Type.";
        toast.error('Employee Type already using cannot delete');
      } else {
        console.error("Error removing Employee Type:", error);
        toast.error("Error deleting Employee Type. Please try again.");
      }
    }
 
  };



  const openModal = (employeeTypeId) => {
    setDeleteEmpTypeID(employeeTypeId); // Store the ProfitCenter ID
    setIsModalOpen(true); // Open the modal
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false); // Close the modal
    setDeleteEmpTypeID(null); // Clear the stored ID
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    console.log("FGFG", deleteEmpTypeId);

    if (deleteEmpTypeId) {
      handleDelete(deleteEmpTypeId); // Call handleDelete with the stored ID
    }
    closeModal(); // Close the modal after confirming
  };
  //
  const columnsFilter = [
    {
      name: "Sl No", selector: (row, index) => index + 1,  sortable: true, grow: 0,
      sortable: true,
       grow: 0,
      width: "80px"
    },
    {
      name: " Name",
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: " Narration",
      selector: (row) => row.Narration,
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.Code,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditEmployeeTypeModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];


  const filteredItems = dataFilter.filter(
    (item) =>
      // item.Id.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Name.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Code?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Narration?.toLowerCase().includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = useMemo(() => {
   
  }, [filterText, resetPaginationToggle]);

  const clearData = () => {
    setEmployeeTypeData({
      Id: "",
      Name: "",
      Narration: "",
      Code: "",
      PayRole: "",
      UserId: UID,
    });
  };
  const clearDataForEdit = () => {
    setEmployeeTypeData((ref) => ({
      ...ref, // Spread the previous state
      Name: "",
      Narration: "",
      Code: "",
      PayRole: "",
      UserId: UID,
    }));
  };

  useEffect(() => {
    setLoading(true);
    fetchEmployeeTypes();
  }, []);

  useEffect(() => {
    if (employeeTypes && employeeTypes.length > 0) {
      const updatedData = employeeTypes.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        Name: item.Name || "",
        Narration: item.Narration || "",
        Code: item.Code || "",
        PayRole: item.PayroleId || "",
        UserId: UID,
        // DepartmentId: item.DepartmentId || "",
      }));
      setDataFilter(updatedData);
    }else{
      setDataFilter([])
    }
  }, [employeeTypes]);

  // Category fetch
  useEffect(() => {
    const fetchPayrole = async () => {
      try {
        const response = await getPayRoleType(UID);
        setPayrole(response.data.data);
        console.log(payrole, "pro");
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };

    fetchPayrole();
  }, []);


  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>

      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Employee Type?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete} // Confirm the deletion
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
     <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Employee Type" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search here..."
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddEmployeeTypeModal}
            className="btn btn-primary"
          >
            Add New
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={employeeTypes} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
{/* =====================================================Add===================================================== */}

      {addEmployeeTypeModal && (
        <>
          <form onSubmit={handleSubmit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Add EmployeeType
                  <span className="absolute top-0 right-0">
                    <button
                      type="button"
                      onClick={openAddEmployeeTypeModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="Name"
                        placeholder="Name"
                        value={employeeTypeData.Name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Narration </label>
                      <input
                        type="text"
                        id="narration"
                        name="Narration"
                        placeholder="Narration"
                        value={employeeTypeData.Narration}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Code <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="code"
                        name="Code"
                        placeholder="Code"
                        value={employeeTypeData.Code}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Payroll <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="PayRole"
                        value={employeeTypeData.PayRole}
                        onChange={handleChange}
                        required
                      >
                        <option key="" value="" >
                          Select Payroll
                        </option>
                        {payrole.map((data) => (
                          <option key={data.Id} value={data.Id}>
                            {data.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button type="submit" disabled={isloading} className="btn btn-primary">
                    Add
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div
            // onClick={openAddEmployeeTypeModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

{/* =====================================================Edit===================================================== */}
      {editEmployeeTypeModal && (
        <>
          <form onSubmit={handleEdit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Edit EmployeeType
                  <span className="absolute top-0 right-0">
                    <button onClick={openEditEmployeeTypeModal} className="btn flex items-center justify-center">
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Name <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        id="Name"
                        name="Name"
                        placeholder="Name"
                        value={employeeTypeData.Name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Narration </label>
                      <input
                        type="text"
                        id="Narration"
                        name="Narration"
                        placeholder="Narration"
                        value={employeeTypeData.Narration}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Code <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        id="Code"
                        name="Code"
                        placeholder="Code"
                        value={employeeTypeData.Code}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>Payroll <span style={{ color: 'red' }}>*</span></label>
                      <select
                        name="PayRole"
                        value={employeeTypeData.PayRole}
                        onChange={handleChange}
                        required
                      >
                        <option key="" value="" >
                          Select Payroll
                        </option>
                        {payrole.map((data) => (
                          <option key={data.Id} value={data.Id}>
                            {data.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button disabled={isloading} className="btn btn-primary">
                    Edit
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div
            // onClick={openEditEmployeeTypeModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
